import http from "@/utils/request";

// 获取分词
export function getJiebaApi(data: any) {
  return http({
    url: `/api/v2/jieba`,
    method: "post",
    data,
    httpType: "gptApi",
  } as any);
}
